(function () {
  var TRACKING_BASE_URL = 'https://app.melhorrastreio.com.br/app/';

  function init() {
    var toggle = document.getElementById('m-order-tracking-toggle');
    var modal = document.getElementById('m-order-tracking-modal');
    var input = document.getElementById('m-order-tracking-input');
    var submit = document.getElementById('m-order-tracking-submit');

    if (!toggle || !modal) return;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = modal.getAttribute('aria-hidden') === 'false';
      if (isOpen) {
        closeModal(modal, toggle);
      } else {
        openModal(modal, toggle, input);
      }
    });

    submit.addEventListener('click', function () {
      track(input);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') track(input);
    });

    document.addEventListener('click', function (e) {
      var wrapper = document.getElementById('m-order-tracking-wrapper');
      if (wrapper && !wrapper.contains(e.target)) {
        closeModal(modal, toggle);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal(modal, toggle);
    });
  }

  function openModal(modal, toggle, input) {
    modal.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }

  function closeModal(modal, toggle) {
    modal.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
  }

  function track(input) {
    var code = input.value.trim();
    if (!code) {
      input.focus();
      return;
    }
    window.open(TRACKING_BASE_URL + encodeURIComponent(code), '_blank', 'noopener,noreferrer');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
